import type { InjectionKey } from 'vue'
import type { WebmapMapManager } from '@/composables/map-x/use-map-manager'

/**
 * Vue injection key for MapManager allows component access via the useMapManager composable
 */
export const WEBMAP_MAP_MANAGER_KEY: InjectionKey<WebmapMapManager> =
  Symbol('webmap-map-manager')
